<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
      </div>

      <el-table ref="multipleTable" border v-loading="loading" :data="tableData" :max-height="tableHeight"
        style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <!-- row-key="id" <el-table-column fixed :reserve-selection="true" prop="selection" type="selection" width="55" align="center"></el-table-column> -->
        <el-table-column fixed type="index" width="55" align="center" label="序号"></el-table-column>
        <el-table-column prop="priceMonitorHospitalId" width="120" label="平台医院编号"
          show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="priceMonitorTypeName" width="110" label="价格监管平台类型" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="companyId" width="170" label="平台企业编码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyName" min-width="160" label="平台企业名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyTypeName" width="80" show-overflow-tooltip label="企业类型"></el-table-column>
        <el-table-column prop="areaId" width="120" label="所在地区ID" show-overflow-tooltip></el-table-column>
        <el-table-column prop="areaName" width="120" label="所属地区" show-overflow-tooltip></el-table-column>
        <el-table-column prop="loginUserName" width="140" label="企业账号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="businessLicense" width="135" label="统一社会信用代码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="addTime" width="170" label="记录添加时间" show-overflow-tooltip>
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.addTime))
            }}</template>
        </el-table-column>
        <el-table-column prop="companyContactTel" width="120" label="企业联系电话" show-overflow-tooltip></el-table-column>
        <el-table-column prop="lastUpdateTime" width="170" label="最后一次更新记录时间" show-overflow-tooltip>
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.lastUpdateTime))
            }}</template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { GetCompanys } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import BaseListMixin from "@/mixin/baseList-mixin.js";
import { PriceMonitorCompanyTypeOptions, PriceMonitorTypeOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data() {
    return {
      GetDatasAction: GetCompanys,
      PriceMonitorCompanyTypeOptions: PriceMonitorCompanyTypeOptions,
      PriceMonitorTypeOptions: PriceMonitorTypeOptions,
      filterOptions: [
        {
          name: "平台企业编码",
          type: "input",
          code: "companyId",
        },
        {
          name: "平台企业名称",
          type: "input",
          code: "companyName",
        },
        {
          name: "平台企业类型",
          type: "select",
          code: "companyType",
          data: PriceMonitorCompanyTypeOptions,
        },
      ],
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        priceMonitorType: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
    };
  },
  methods: {
    // 获取列表
    getData() {
      this.GetDatasAction(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;

        // this.getSpanArr(this.tableData)
      });
    },
    // 改变当前页
    changePage(val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 重置
    reset() {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        priceMonitorType: 1,
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.getData();
    },
    queryChange() {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  created() { },
};
</script>

<style lang="scss" scoped></style>
